import axios from "axios";

const KEY = "AIzaSyBbY61i2Gwj2IbXfyC1u1Zn6H2KFrr2S8I"; // Replace this with your actual key

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    maxResults: 8,
    key: KEY,
  },
});
